import React from 'react';
import {
  Box,
  Typography,
  Button,
} from '@mui/material';
import OffersStandaloneTab from '../components/offers/OffersStandaloneTab';

const OffersPage: React.FC = () => {
  const handleOpenAddForm = () => {
    // Otwórz formularz w OffersStandaloneTab
    if ((window as any).__openOffersAddForm) {
      (window as any).__openOffersAddForm();
    }
  };

  const handleRefreshNeeded = () => {
    // Ta funkcja będzie wywoływana przez OffersStandaloneTab po dodaniu oferty
    // Nie trzeba nic robić, ponieważ OffersStandaloneTab sam odświeża dane
  };

  return (
    <Box sx={{ bgcolor: '#FAFAFA', mt: '20px' }}>
      {/* Nagłówek i przycisk Dodaj */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mt: 0, mb: 2 }}>
        <Typography
          component="h1"
          sx={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: '20px',
            lineHeight: '24px',
            fontWeight: 400,
            color: '#020242',
            m: 0,
            mt: '8.5px'
          }}
        >
          Oferty
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
          <Button 
            variant="contained" 
            onClick={handleOpenAddForm}
            data-action="add"
            data-hotkey-add="true"
            sx={{ 
              width: 116,
              height: 40,
              borderRadius: '4px',
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 600,
              backgroundColor: '#4040DB',
              color: '#fff',
              '&:hover': { backgroundColor: '#1F1FB0' },
              '&:active': { backgroundColor: '#1A1A98' }
            }}
          >
            Dodaj ofertę
          </Button>
        </Box>
      </Box>

      {/* Renderujemy OffersStandaloneTab, który zawiera całą logikę filtrów i tabeli */}
      <OffersStandaloneTab onRefreshNeeded={handleRefreshNeeded} />
    </Box>
  );
};

export default OffersPage;
